import { useEffect } from "react";
import deployment from "../../data/deployment.json";

const STORAGE_KEY = "nextech-deployment-release";

/**
 * Removes browser-managed application caches when a newly built release is
 * first opened. Static files and social images also receive new URLs at build
 * time, so this is a safety net for any old service worker or Cache Storage
 * entries left by an earlier version of the site.
 */
const CacheReleaseManager = () => {
  useEffect(() => {
    const clearPreviousRelease = async () => {
      let previousRelease = null;
      try {
        previousRelease = window.localStorage.getItem(STORAGE_KEY);
      } catch (error) {
        // Storage can be unavailable in private or restricted browser modes.
      }

      if (previousRelease === deployment.id) return;

      if ("serviceWorker" in navigator) {
        const registrations = await navigator.serviceWorker.getRegistrations();
        await Promise.all(registrations.map((registration) => registration.unregister()));
      }

      if ("caches" in window) {
        const cacheNames = await window.caches.keys();
        await Promise.all(cacheNames.map((cacheName) => window.caches.delete(cacheName)));
      }

      try {
        window.localStorage.setItem(STORAGE_KEY, deployment.id);
      } catch (error) {
        // Cache cleanup still succeeds when persistent storage is unavailable.
      }
    };

    clearPreviousRelease().catch(() => {
      // Cache APIs are optional; a failure must never prevent the site loading.
    });
  }, []);

  return null;
};

export default CacheReleaseManager;
